// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Q9-z","fadeIn":"R9-z","delay":"S9-z","recommendedSizeTooltip":"T9-z"};